export const AlignRightIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width="16"
    height="16"
    className={className}
    style={{ display: "block" }}
  >
    <path
      d="M14.6665 14.6654V1.33203H13.3332V14.6654H14.6665ZM11.9998 11.332V9.33203H5.33317V11.332H11.9998ZM11.9998 6.66536V4.66536H1.33317V6.66536H11.9998Z"
      fill="#1A2547"
    />
  </svg>
);
